import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import useFormatToken from "../useFormatToken";
import {
  setFromAmount,
  setFromChain,
  setToChain,
} from "../redux/slices/coreInfoSlice";
import { setTokenChainsFrom, setTokenChainsTo } from "../redux/slices/appSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import useChainsForToken from "hooks/useChainsForToken";

const useBrc20DefData = () => {
  const { chainsByBrc20: chains, tokensByBrc20: tokens } = useAppSelector((state) => state.app);
  const { formatToken } = useFormatToken();
  const { chainsByToken } = useChainsForToken()
  const dispatch = useAppDispatch();
  const { fromChain, toChain, fromToken, toToken, fromAmount } = useAppSelector(
    (state) => state.coreInfo
  );
  let [searchParams] = useSearchParams();
  let navigate = useNavigate();

  const [isFirst, setIsFirst] = useState(false);

  useEffect(() => {
    if (!isFirst && tokens && chains && chains.length && tokens.length) {
      setIsFirst(true);
      let defFromChain = searchParams.get("fromChain");
      let defToChain = searchParams.get("toChain");
      let defFromToken = searchParams.get("fromToken");
      let defToToken = searchParams.get("toToken");
      let defFromAmount = searchParams.get("fromAmount");

      if(sessionStorage.getItem('transParamsBrc20')) {
        const transParams = sessionStorage.getItem('transParamsBrc20')
        const transParamsList = transParams?.split('&')
        const transParamsObj: {[key: string]: any} = {}
        transParamsList?.forEach(item => {
          const [key, value] = item.split('=')
          transParamsObj[key] = value
        })
        if(transParamsObj['fromChain']) {
          defFromChain = transParamsObj['fromChain']
        }
        if(transParamsObj['toChain']) {
          defToChain = transParamsObj['toChain']
        }
        if(transParamsObj['fromToken']) {
          defFromToken = transParamsObj['fromToken']
        }
        if(transParamsObj['toToken']) {
          defToToken = transParamsObj['toToken']
        }
        if(transParamsObj['fromAmount']) {
          defFromAmount = transParamsObj['fromAmount']
        }
      }

      const tempFromChain = chains.find(
        (item) => item.nickName === (defFromChain || "BTC")
      );
      const tempToChain = chains.find(
        (item) => item.nickName === (defToChain || "BNB")
      );
      const tempFromToken = tokens.find(
        (item) => item.symbol === (defFromToken || "ordi")
      );
      const tempToToken = tokens.find(
        (item) => item.symbol === (defToToken || "ordi")
      );

      if (tempFromChain) {
        dispatch(setFromChain(tempFromChain));
      }
      if (tempToChain) {
        dispatch(setToChain(tempToChain));
      }

      if (tempFromChain && tempFromToken) {
        dispatch(setTokenChainsFrom(tempFromToken));
        chainsByToken(tempFromToken, "from", chains)
        formatToken(tempFromToken, tempFromChain, "from");
      }

      if (tempToChain && tempToToken) {
        dispatch(setTokenChainsTo(tempToToken));
        chainsByToken(tempToToken, "to", chains)
        formatToken(tempToToken, tempToChain, "to");
      }

      if (defFromAmount) {
        dispatch(setFromAmount(defFromAmount));
      }
    }
  }, [tokens, chains, dispatch, formatToken, searchParams, isFirst, chainsByToken]);

  useEffect(() => {
    let queryStr = [];
    if (fromChain?.nickName) {
      queryStr.push(`fromChain=${fromChain?.nickName}`);
    }
    if (toChain?.nickName) {
      queryStr.push(`toChain=${toChain?.nickName}`);
    }
    if (fromToken?.symbol) {
      queryStr.push(`fromToken=${fromToken?.symbol}`);
    }
    if (toToken?.symbol) {
      queryStr.push(`toToken=${toToken?.symbol}`);
    }
    if (fromAmount) {
      queryStr.push(`fromAmount=${fromAmount}`);
    }

    if (queryStr.length) {
      sessionStorage.setItem("transParamsBrc20", `${queryStr.join("&")}`);
      navigate(`/brc20?${queryStr.join("&")}`);
    }
  }, [
    fromChain,
    toChain,
    fromAmount,
    navigate,
    fromToken?.symbol,
    toToken?.symbol,
  ]);
};

export default useBrc20DefData;
